"use strict";

import {onEnterViewPort} from "@elements/viewport-utils";
import {default as initMap, setMarker, loadGoogleMapsAPI, showInfoBoxByMarker, closeInfoBoxByMarker} from "@elements/google-map";

export function initInScope($scope) {
    let $maps  = $scope.find('.js-google-map');

    if ($maps && $maps.length) {

        $maps.each(function (index, element) {
            let $container = $(element);
            let $mapCanvas = $container.find('.js-google-map__canvas');

            onEnterViewPort($(element), function () {
                loadGoogleMapsAPI().then(function () {
                    const poiStyles = {
                        default: {
                            default: {
                                url: '/static/build/img/map/poi.svg',
                                size: new google.maps.Size(30, 38),
                                scaledSize: new google.maps.Size(30, 38),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(15, 38)
                            },
                            active: {
                                url: '/static/build/img/map/poi-active.svg',
                                size: new google.maps.Size(30, 38),
                                scaledSize: new google.maps.Size(30, 38),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(15, 38)
                            }
                        }
                    };

                    let clusteringOptions = {
                        default: {
                            styles: [{
                                height: 37,
                                url: "/static/build/img/map/cluster.svg",
                                width: 30,
                                anchor: [-7,-7],
                                textSize: 14,
                                textColor: "#2A292A"
                            }]
                        },
                        active: {
                            styles: [{
                                height: 37,
                                url: "/static/build/img/map/cluster.svg",
                                width: 30,
                                anchor: [-7,-7],
                                textSize: 14,
                                textColor: "#2A292A"
                            }]
                        }
                    };

                    let options = $container.data('google-map-options');
                    let poiVarName = $container.data('google-map-pois');
                    let pois = [];

                    if (poiVarName) {
                        if (!window['_googleMapPois']) {
                            console.error('_googleMapPois is not set');
                        } else if (!window._googleMapPois[poiVarName]) {
                            console.error(poiVarName + ' is not set in _googleMapPois', _googleMapPois);
                        } else {
                            pois = _googleMapPois[poiVarName];
                        }
                    }

                    let mapObj = initMap({
                        element: $mapCanvas[0],
                        mapOptions: options,
                        poiStyles,
                        clustering: true,
                        clusteringOptions,
                        // onActivateMarker,
                        // onDeactivateMarker
                    });

                    setMarker(mapObj, pois);
                }).catch(function (a,b,c) {
                    console.error(a,b,c);
                });
            }, {
                offset: window.innerHeight * 1.5
            });
        });
    }
}

// function onActivateMarker(marker, mapObj) {
//     let detailArea = $('.js-google-map__detail-area');
//
//     if(marker.detailInfoBoxUrl) {
//         let infoBoxPromise = showInfoBoxByMarker(
//             marker,
//             `<div class="my-2">
//                 <div class="loading-spinner" aria-label="Loading...">
//                     <div class="loading-spinner__item loading-spinner__item--1"></div>
//                     <div class="loading-spinner__item loading-spinner__item--2"></div>
//                     <div class="loading-spinner__item loading-spinner__item--3"></div>
//                 </div>
//             </div>`,
//             mapObj
//         );
//
//         let contentPromise = $.ajax(marker.detailInfoBoxUrl, {
//             cache: true,
//             dataType: 'html',
//             headers: {Ajax: 1}
//         }).catch(function (a, b, c) {
//             console.error(a, b, c);
//         });
//
//         contentPromise.then(function (infoBoxMarkup) {
//             detailArea.html(infoBoxMarkup);
//         });
//
//         $.when(infoBoxPromise, contentPromise).then(function (infoBox, [infoBoxContent]) {
//             if(infoBox.getVisible()) {
//                 // open the new info box with the new content only if the old one is still open
//                 infoBox.setContent(infoBoxContent);
//             }
//         });
//     }
// }
//
// function onDeactivateMarker(marker, mapObj) {
//     closeInfoBoxByMarker(marker, mapObj);
//
//     let detailArea = $('.js-google-map__detail-area');
//     detailArea.html("");
// }